import { venue } from '../../data/landingData';
import { MapPin, Plane, ExternalLink, Check } from 'lucide-react';

export const Venue = () => {
  return (
    <section 
      id="venue" 
      className="py-24 px-6 bg-[#0A0A0A]"
      data-testid="venue-section"
    >
      <div className="max-w-7xl mx-auto">
        {/* Section header */}
        <div className="text-center mb-16">
          <p className="text-[#D4AF37] font-manrope uppercase tracking-[0.2em] text-xs font-bold mb-4">
            Your Sanctuary
          </p>
          <h2 className="font-cormorant text-4xl md:text-5xl font-medium text-white mb-4">
            {venue.name}
          </h2>
          <p className="text-zinc-400 font-manrope">
            {venue.location}
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Images */}
          <div className="space-y-6">
            <div className="aspect-video rounded-2xl overflow-hidden">
              <img
                src="https://images.unsplash.com/photo-1773424216455-a936cba886c3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwyfHxhZXJpYWwlMjBQYW5hbWElMjBDaXR5JTIwUGFuYW1hJTIwc2t5bGluZSUyMG9jZWFufGVufDB8fHx8MTc3NDcwNTk4NHww&ixlib=rb-4.1.0&q=85"
                alt="Aerial view of Panama City skyline at sunset"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="grid grid-cols-2 gap-6">
              <div className="aspect-square rounded-xl overflow-hidden">
                <img
                  src="https://images.unsplash.com/photo-1773424210357-7ba8d1b2e0f3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwxfHxhZXJpYWwlMjBQYW5hbWElMjBDaXR5JTIwUGFuYW1hJTIwc2t5bGluZSUyMG9jZWFufGVufDB8fHx8MTc3NDcwNTk4NHww&ixlib=rb-4.1.0&q=85"
                  alt="Panama City modern waterfront"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="aspect-square rounded-xl overflow-hidden">
                <img
                  src="https://customer-assets.emergentagent.com/job_analytics-live-1/artifacts/wgp3126n_PXL_20250724_172937751.jpg"
                  alt="Fresh tropical fruits - authentic Panama cuisine"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>

          {/* Info */}
          <div className="space-y-8">
            {/* Location info */}
            <div className="bg-[#111111] border border-white/5 rounded-2xl p-8">
              <h3 className="font-cormorant text-2xl font-medium text-white mb-4">
                Location
              </h3>
              <div className="space-y-4 mb-6">
                <div className="flex items-start gap-3">
                  <MapPin className="w-5 h-5 text-[#D4AF37] flex-shrink-0 mt-0.5" />
                  <div>
                    <p className="text-white font-manrope">{venue.name}</p>
                    <p className="text-zinc-500 font-manrope text-sm">{venue.location}</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <Plane className="w-5 h-5 text-[#D4AF37] flex-shrink-0 mt-0.5" />
                  <p className="text-zinc-400 font-manrope text-sm">{venue.distance}</p>
                </div>
              </div>
              <a
                href={venue.website}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-[#D4AF37] hover:text-[#B8860B] font-manrope text-sm transition-colors"
                data-testid="venue-website-link"
              >
                View Hotel Website
                <ExternalLink className="w-4 h-4" />
              </a>
            </div>

            {/* Accommodations */}
            <div className="bg-[#111111] border border-white/5 rounded-2xl p-8">
              <h3 className="font-cormorant text-2xl font-medium text-white mb-4">
                Accommodations
              </h3>
              <ul className="space-y-3">
                {venue.amenities.map((amenity, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <Check className="w-4 h-4 text-[#D4AF37] flex-shrink-0 mt-1" />
                    <span className="text-zinc-400 font-manrope text-sm">{amenity}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Travel info */}
            <div className="grid grid-cols-2 gap-4">
              <div className="bg-[#111111] border border-white/5 rounded-xl p-6 text-center">
                <p className="text-[#D4AF37] font-manrope text-xs uppercase tracking-wider mb-2">Arrival</p>
                <p className="text-white font-cormorant text-xl">Thursday</p>
                <p className="text-zinc-500 font-manrope text-sm">July 23, 2026</p>
                <p className="text-zinc-600 font-manrope text-xs mt-1">Before 9:00 PM</p>
              </div>
              <div className="bg-[#111111] border border-white/5 rounded-xl p-6 text-center">
                <p className="text-[#D4AF37] font-manrope text-xs uppercase tracking-wider mb-2">Departure</p>
                <p className="text-white font-cormorant text-xl">Sunday</p>
                <p className="text-zinc-500 font-manrope text-sm">July 26, 2026</p>
                <p className="text-zinc-600 font-manrope text-xs mt-1">By 2:00 PM</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
